import React from 'react';
import $t from 'translation';
import {Link} from '@mui/material';
import {detect} from 'detect-browser';
import Typography from '@mui/material/Typography';
import Urls from 'features/metamask/constants/metamask-extension-urls';
import Grid from '@mui/material/Unstable_Grid2';
import styles from './styles';

const InstallMetamask = () => {
  const browser = detect();
  let url = '';
  switch (browser?.name) {
    case 'chrome':
      url = Urls.CHROME;
      break;

    case 'firefox':
      url = Urls.FIREFOX;
      break;

    case 'edge-chromium':
      url = Urls.EDGE_CHROMIUM;
      break;

    case 'opera':
      url = Urls.OPERA;
      break;

    default:
      break;
  }

  return (
    <Grid sx={styles.root}>
      {url ? (
        <Typography variant={'body1'}>
          {$t('auth.form.install.plugin')}
          <Link
            href={url}
            target={'_blank'}
            sx={styles.link}
          >
            {$t('auth.form.metamask.plugin')}
          </Link>
          {$t('auth.form.install.plugin.description')}
        </Typography>
      ) : (
        <Typography variant={'body1'}>{$t('auth.form.plugin.not.supported')}</Typography>
      )
      }
    </Grid>
  );
};

export default InstallMetamask;